import React, { useState } from 'react'

export default function Login({ onLogin }) {
  const [password, setPassword] = useState('')
  const [error, setError] = useState(false)
  const [shaking, setShaking] = useState(false)

  function handleSubmit(e) {
    e.preventDefault()
    const correct = process.env.REACT_APP_DASHBOARD_PASSWORD
    if (password === correct) {
      sessionStorage.setItem('im_auth', '1')
      onLogin()
    } else {
      setError(true)
      setShaking(true)
      setPassword('')
      setTimeout(() => setShaking(false), 500)
    }
  }

  return (
    <div className="login-screen">
      <div className={'login-box' + (shaking ? ' login-shake' : '')}>
        <div className="login-logo">
          <span className="login-triangle">▲</span>
          <span className="login-wordmark">INSIDE MAG</span>
        </div>
        <p className="login-sub">editorial</p>
        <form onSubmit={handleSubmit} className="login-form">
          <input
            className={'login-input' + (error ? ' login-input--error' : '')}
            type="password"
            value={password}
            onChange={e => { setPassword(e.target.value); setError(false) }}
            placeholder="Password"
            autoFocus
          />
          {error && <p className="login-error">Incorrect password</p>}
          <button className="login-btn" type="submit">Enter</button>
        </form>
      </div>
    </div>
  )
}
